import { useSelector } from 'react-redux';

export {
    Colors,
    Shadow,
    Backgrounds,
    useGlobalStyles,
    useGlobalTextStyles,
    useGlobalText,
    createInputsWrapper,
    AntSwitch,
    globalModals,
} from './globalStylesUi';
export { Images } from './images';
export { EmailValidator, PasswordValidator, DomainNameValidator, URLValidator, UrlRegex, OnlyNumber } from './validations';
export { superAdminRouters } from './routers';
export {
    PermissionsList,
    paginate,
    filterByFirstName,
    initAxiosInterceptors,
    activeInactive,
    ToastSuccess,
    ToastFail,
    FindSuccessItem,
    FindSuccess,
    FindLoad,
    FindLoadItem,
    FindError,
    ActiveInactiveStatus,
    ActiveInactiveStatusReverse,
    getPhoneErrorText,
    isNotEmpty,
    makeEnum,
    transformPermission,
    getValTillTenDig,
    getLimitedVal,
    manageStatus,
    getMenuTitle,
    makeCapitalize,
    useWidth,
    hooksForTable,
    // ImgUploader,
    hooksForErrors,
    addHiddenClass,
    ssnActions,
    createCodeFromName,
    getSkipCount,
    useWeekInterval,
    manageType,
    textResizer,
    handleTooltip,
    FindErrorItem,
    getDisplayDependsOnWidth,
    SavePage,
    SendPageSave,
    SaveParams,
    gridFilterTab,
    restoredGridState,
    persistGridFilters,
    cancelPendingGridFilterSaves,
    PascalCase,
    manageStatusCircle,
    convertHours,
    CPT_SERVICE_DELIMITER,
    makeCptServiceOptionId,
    formatServiceCodeLabel,
    splitCptServiceFilter,
    cptServiceLabel,
    RolePermission,
    PermissionList,
    multiConverter,
    convertToDateTime,
    DownloadFile,
    getFreshFileUrl,
    previewFile,
    formatAMPM,
    filterFromTable,
    InactivityHandler,
    useScrollTop,
    formatMiles,
    TimeIsGreat,
    formatAMPMNeW,
    renderSize,
    getFileType,
    base64ToFile,
    newDateWithoutUtc,
    renderClientName,
    renderStaffName,
    IsImageLoaded,
    getNestedError,
    renderDate,
    renderDateRange,
    checkIfDateIsExpired,
    toCamelCase,
    formatHours,
    sortAlphabetically,
    saveLocalParams,
    formatType,
    sortListByKey,
    convertTo12HourFormat,
    renderFirstLetters,
    formatNumberToFix,
    formatSeconds,
    getMonthsBetweenDates,
    convertSecondToMinute,
    stripHtml,
    formatSecondDuration,
    SessionSocket,
    useSessionSocket,
    renderGoalValueType,
    formatAMPMWidthSecond,
    loadGoogleMaps,
    formatAddress,
    addressPlace,
    isUSAddress,
} from './hooks';
export { ErrorText } from './errorTexts';
export { CountryList, states } from './jsons';
export { languages, languagesById } from './languages';
export {
    list,
    getDataForTable,
    getGeneratingDataForTable,
    getModalDataForTable,
    formatIssueType,
    apptIssueType,
    apptErrors,
    getApptErrorOptions,
    KeyPurpose,
    CONTENT_TYPE_ALLOWLIST_BY_PURPOSE,
    MAX_BYTES_BY_PURPOSE,
    INSTRUCTIONS_MAX_LENGTH,
    CALENDLY_URL,
    MAX_AUTHORIZATION_ID_LENGTH,
    ApptAddressType,
    apptAddressTypeLabels,
    apptAddressGroupLabels,
    renderLabeledAddress,
    TimeInputMinuteStep,
    timeInputMinuteStepOptions,
} from './constants';
export {
    DrawerContext,
    DrawerContextProvider,
    AllModals,
    ModalProvider,
    useModal,
    SecondaryModalProvider,
    SecondaryModals,
    useSecondaryModal,
    useBaseModal,
    BaseModalProvider,
    BaseModals,
} from './contexts';

export {
    reqTypeEnums,
    enumValues,
    FLAGGED_ENUMS,
    FLAGGED,
    UNFLAGGED,
    FLAGGED_VALUES,
    PAYROLL_FLAGGED_ENUMS,
    APPT_FLAGGED_ENUMS,
    APPT_ENUMS,
    agingEnumsSelector,
    agingEnums,
    clientStatuses,
    credentialTypesEnums,
    activeInactiveEnums,
    tagEnums,
    staffStatuses,
    staffStatusEnums,
    clientStatusEnums,
    authUtilizationStatusEnums,
    authUtilizationFilterStatusEnums,
    authUtilizationStatuses,
    authUtilizationPeriodEnums,
    authUtilizationStateEnums,
    noteModels,
    commentModels,
    claimStatusEnumList,
    goalDataTypes,
    goalDataTypeEnums,
    trialStatusEnums,
    sessionStatusEnums,
    renderGoalTypes,
    apptEnums,
    orgIntegrationEnums,
    renderIntervalText,
    evalModeEnums,
    masteryEvalTypeEnums,
    masteryEvalTypeList,
    firstTrialResponseEnums,
    firstTrialResponseList,
    durationCalcEnums,
    durationCalcList,
    graphValueModeEnums,
    onModelFolderEnum,
    masteryDirectionEnums,
    masteryDirectionList,
    targetStatusEnums,
    renderTargetStatuses,
    isMaintenanceRunning,
    isMaintenanceCompleted,
    maintenanceBadges,
    videoModelEnums,
    claimStatusEnumsList,
    claimEnums,
    goalPerRateEnumList,
    globalSessionENums,
    fileEnums,
    attributeTypes,
    userTypeEnums,
    scheduleViewEnum,
    noteStatusEnums,
} from './enumValues';
import { orgIntegrationEnums } from './enumValues';
export { sanitizeHtml } from './sanitize';
export { getCalendlyUtmParams, captureUtmParams } from './utm';
// export const token = localStorage.getItem('access-token');
export const token = () => require('./crypto').getToken();

export const User = () => {
    const reducerUser = useSelector((state) => state.auth.userInfo);
    let localUser = null;
    try {
        localUser = require('./crypto').getUserInfo();
    } catch (e) {
        // Corrupt localStorage data — ignore
    }

    const userInfo = reducerUser || localUser;
    return { userInfo };
};

export const OrgIntegrations = () => {
    let localUser = null;
    try {
        localUser = require('./crypto').getUserInfo();
    } catch (e) {
        // Corrupt localStorage data — ignore
    }
    const companyStore = useSelector((state) => state.system.company);
    const company = companyStore || localUser;
    const voiceNote = company?.orgPermissions?.find((i) => i?.type === orgIntegrationEnums.VOICE_NOTE);
    const cSession = company?.orgPermissions?.find((i) => i?.type === orgIntegrationEnums.C_SESSION);
    const aiBridge = company?.orgPermissions?.find((i) => i?.type === orgIntegrationEnums.AI_BRIDGE);

    return {
        voiceNote: voiceNote?.isActive,
        cSession: cSession?.isActive,
        aiBridge: aiBridge?.isActive,
        // The org's own assistant switch (admin), sent only with the company read — so hidden until that
        // read arrives rather than shown and then pulled. The platform-wide switch is deliberately not here:
        // when it is off the button stays and requests answer "temporarily unavailable".
        aiAssistant: !!aiBridge?.isActive && companyStore?.aiAssistantEnabled === true,
        cSessionInfo: cSession,
        voiceNoteInfo: voiceNote,
        aiBridgeInfo: aiBridge,
    };
};
export {
    DiagnosisMatchStatus,
    ClientDiagnosisStatus,
    clientDiagnosisStatusLabels,
    useDiagnosisMatchEnabled,
    ICD10_CM_CODE_PATTERN,
    MAX_DIAGNOSIS_CODE_LENGTH,
    MAX_DIAGNOSIS_DESCRIPTION_LENGTH,
    formatDiagnosisCode,
} from './diagnosis';
